export const AddressColumns = [
    "s_no",
    "destination",
    "delivery_address",
    "buyer_address",
    "buyer_code",
    "delivery_code",
    'DeliveryCode', 
    'DeliveryAddress',
    'BuyerCode', 
    'BuyerAddress',

  
]